import { Box, Grid, Text } from "@chakra-ui/layout";
import { Trans, t } from "@lingui/macro";
import { ModuleTitle } from "@src/components/ui-kit";
import {
  NavigationCard,
  type NavigationCardObject,
} from "@src/components/ui-kit/navigation-card";
import { observer } from "mobx-react-lite";

const TEMPLATES: NavigationCardObject[] = [
  // {
  //   title: () => t`Budget templates`,
  //   description: () => t`Description 1`,
  //   bg: "cyan.100",
  //   href: "/templates/budget",
  // },
  // {
  //   title: () => t`Task templates`,
  //   description: () => t`Description 3`,
  //   bg: "purple.100",
  //   href: "/templates/task",
  // },
  {
    title: () => t`Task group templates`,
    description:
      () => t`Easily create and manage entire groups of tasks with predefined
          settings. Assign team members, set durations, deadlines, and
          priorities—all in one place. With just one click, you can apply these
          task groups to selected budget items.`,
    bg: "pink.100",
    href: "/templates/task-groups",
  },
  // {
  //   title: () => t`Project templates`,
  //   description: () =>
  //     t`Quickly create fully structured project templates with predefined budgets, task groups, subtasks, or invoicing plans. Perfect for standardizing recurring or complex projects.`,
  //   bg: "orange.100",
  //   href: "/templates/projects",
  // },
];

export const TemplatesPage = observer(function TemplatesPage() {
  return (
    <Box>
      <ModuleTitle>
        <Trans>Templates</Trans>
      </ModuleTitle>

      <Text mt="3">
        <Trans>A collection of all templates</Trans>
      </Text>

      <Grid templateColumns="repeat(2, 1fr)" mt="10" gap="5">
        {TEMPLATES.map((template) => (
          <NavigationCard
            key={`${template.title()}-${template.description()}`}
            href={template.href}
            description={template.description()}
            linkText={t`View templates`}
            title={template.title()}
            backgroundColor={template.bg}
          />
        ))}
      </Grid>
    </Box>
  );
});
